import cx from 'classnames'

import styles from './OuterCard.module.scss'
import { OuterCardProps } from './OuterCard.types'
import { Badge, ButtonText, Flex } from '@percent/lemonade'

export function OuterCard({
  badgeContent,
  badgeVariant = 'default',
  customBgColour = 'default',
  children,
  customHeader,
  dataTestId = 'outer-card',
  expandAll
}: Readonly<OuterCardProps>) {
  const bgClass = customBgColour === 'info' ? styles.infoBg : styles.defaultBg

  return (
    <Flex className={cx(styles.outerCard, bgClass)} data-testid={dataTestId}>
      <Flex align="center">
        {badgeContent && (
          <Flex pb="8px" w="fit-content">
            <div className={styles.badge}>
              <Badge variant={badgeVariant} testId="card-badge">
                {badgeContent}
              </Badge>
            </div>
          </Flex>
        )}
        {customHeader}
        {expandAll && (
          <ButtonText
            size="s"
            className={styles.expandAllButton}
            onClick={expandAll.onClick}
            data-testid="expand-all-button"
          >
            {expandAll.label}
          </ButtonText>
        )}
      </Flex>
      {children}
    </Flex>
  )
}
